import apiService from './api'

export interface Message {
  _id: string
  conversationId: string
  senderId: string | {
    _id: string
    firstName: string
    lastName: string
    email: string
  }
  receiverId: string | {
    _id: string
    firstName: string
    lastName: string
    email: string
  }
  schoolId: string | {
    _id: string
    name: string
  }
  bookingId?: string
  content: string
  isRead: boolean
  readAt?: string
  createdAt: string
  updatedAt: string
}

export interface Conversation {
  conversationId: string
  school: {
    _id: string
    name: string
    logo?: string
  } | null
  otherUser: {
    _id: string
    firstName: string
    lastName: string
    email: string
  } | null
  lastMessage: Message | null
  unreadCount: number
}

export interface ConversationsResponse {
  success: boolean
  data: {
    conversations: Conversation[]
    totalCount: number
    currentPage: number
    totalPages: number
    hasNextPage: boolean
    hasPrevPage: boolean
  }
}

export interface MessagesResponse {
  success: boolean
  data: {
    messages: Message[]
    totalCount: number
    currentPage: number
    totalPages: number
    hasNextPage: boolean
    hasPrevPage: boolean
  }
}

export interface UnreadCountResponse {
  success: boolean
  data: {
    unreadCount: number
  }
}

export const messageService = {
  async sendMessage(schoolId: string, content: string, receiverId?: string, bookingId?: string) {
    return apiService.sendMessage({
      schoolId,
      content,
      receiverId,
      bookingId,
    })
  },

  async getConversations(page: number = 1, limit: number = 20): Promise<ConversationsResponse> {
    return apiService.getConversations({
      page,
      limit,
    })
  },

  async getMessages(conversationId?: string, schoolId?: string, bookingId?: string, page: number = 1, limit: number = 50): Promise<MessagesResponse> {
    const params: any = {
      page,
      limit,
    }
    if (conversationId) {
      params.conversationId = conversationId
    }
    if (schoolId) {
      params.schoolId = schoolId
    }
    if (bookingId) {
      params.bookingId = bookingId
    }
    return apiService.getMessages(params)
  },

  async markAsRead(messageIds: string[]) {
    return apiService.markMessagesAsRead({
      messageIds,
    })
  },

  async getUnreadCount(): Promise<UnreadCountResponse> {
    return apiService.getUnreadCount()
  },
}







